<template>
  <b-tabs content-class="mt-3">
    <images-tab
        ref="tabImages"
        @refresh-data="refreshTabData"
        :entity-id="entityId"
        entity-type="document-library"
    />
    <files-tab
      ref="tabFiles"
      :entity-id="entityId"
      entity-type="document-library"
      @refresh-data="refreshTabData"
    />
    <log-tab
      ref="tabLogTable"
      :entity-id="entityId"
      entity-type="document-library"
    />
  </b-tabs>
</template>

<script>
import {
  BTabs,
} from 'bootstrap-vue'
import imagesTab from '@/views/pages/_components/_tab/_shared/_update/images.vue'
import filesTab from '@/views/pages/_components/_tab/_shared/_update/files.vue'
import logTab from '@/views/pages/_components/_tab/_log/_list.vue'

export default {
  components: {
    BTabs,
    imagesTab,
    filesTab,
    logTab,
  },
  props: {
    entityId: {
      type: Number,
      required: true
    }
  },
  methods: {
    refreshTabData() {
      this.$emit('refresh-tabs-data')
    },
    refreshLog() {
      this.$refs.tabLogTable.initData()
    },
    refreshImages() {
      this.$refs.tabImages.initTab()
    },
    refreshFiles() {
      this.$refs.tabFiles.initTab()
    }
  }
}
</script>

<style scoped>

</style>
